export default {"src":"/_next/static/media/app-store.9f1ac6af.svg","height":238,"width":801,"blurWidth":0,"blurHeight":0};